export default __webpack_public_path__ + "static/media/dzsj.e2c1e305.gif";